import PropTypes from 'prop-types';

const EmptyState = ({ onSuggestionClick }) => {
  const suggestions = [
    "Show me all the lots you've created",
    "Show all scans in the USA on a map",
    "Show me the contents of a pallet",
    "List the products in the system"
  ];

  return (
    <div className="flex-1 flex items-center justify-center p-6 animate-fadeIn">
      <div className="max-w-2xl w-full text-center">
        {/* AI Avatar */}
        <div className="flex justify-center mb-6">
          <div className="w-16 h-16 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center text-white text-2xl font-semibold shadow-lg">
            AI
          </div>
        </div>

        {/* Welcome Message */}
        <p className="text-base text-gray-600 mb-8 leading-relaxed">
          Ask questions about your EPCIS supply chain data. I can help you analyze events,
          track products, generate insights, and visualize your data.
        </p>

        {/* Suggestions */}
        <div className="space-y-3">
          <p className="text-sm font-medium text-gray-700 mb-4">
            Try asking:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {suggestions.map((suggestion, index) => (
              <button
                key={index}
                onClick={() => onSuggestionClick && onSuggestionClick(suggestion)}
                className="px-4 py-3 text-sm text-left text-gray-700 bg-white border border-gray-200 rounded-lg hover:border-blue-300 hover:bg-blue-50 hover:shadow-sm transition-all duration-200"
              >
                {suggestion}
              </button>
            ))}
          </div>
        </div>

        {/* Quick Tips */}
        <div className="mt-8 pt-6 border-t border-gray-200">
          <p className="text-xs text-gray-500 leading-relaxed">
            <span className="font-medium">Tip:</span> You can ask about specific time ranges,
            locations, products, or event types. I'll provide visualizations and insights
            automatically.
          </p>
        </div>
      </div>
    </div>
  );
};

EmptyState.propTypes = {
  onSuggestionClick: PropTypes.func
};

export default EmptyState;
